import React, { Component } from 'react'
import { connect } from 'react-redux'
import MessagingInbox from './MessagingInbox'
import MessagingConfirmedEvents from './MessagingConfirmedEvents'
import DefaultPage from '../../Container/Layout/DefaultPage'
import { getUserProfile, getConnectedEvent } from '../../firebase/database/handleUserMgm'
import PopUp from '../../Container/PopUps/PopUp'
import { doSetConfirmedEvent, rejectConnectedEvent } from '../../firebase/database/handleEvents'
//import {listenMyConfirmedEvents} from '../../firebase/database/handleEvents'

class MyMessagingCenter extends Component {
    constructor(props) {
        super(props);
    
        this.state   = {
            clickedMessageId: null,
            clickedArrIndex: null,
            clickedRequesterData: null,
            clickedConnectedEvent: null,
            clickedConfirmedEventArrIndex: null,
            clickedConfirmedEventId: null,
            popUp: {
                active: false,
                type: null,
                title: null,
                content: null,
                buttonConfig: null,
                userInput: '',

            }
            
        } //this.toggleView = this.toggleView.bind(this)
    }

    async componentWillMount () {
       
       
    }
  

    //props.dispatchFunction(test)
    notificationHeadline='Hilfeangebot Bestätigt'
    notificationContent = 'Vielen Dank. Die Geschäftsstelle wird über die Bestätigung informiert'
    notificationItem = {
        headline: this.notificationHeadline,
        content: this.notificationContent
    }

    itemClickCallback = async (messageId, arrIndex) => {
        const { requesterId, eventId} = this.props.myInboxMessages[arrIndex].ids
    
        const requesterData = await getUserProfile(requesterId)
        const connectedEvent = await getConnectedEvent(eventId)
        this.setState({clickedMessageId: messageId, clickedArrIndex: arrIndex, clickedRequesterData: requesterData, clickedConnectedEvent: connectedEvent})
     
    }

    confirmedItemClickCallback = (eventId, arrId) => {
        this.setState({
            clickedConfirmedEventArrIndex: arrId,
            clickedConfirmedEventId: eventId,
        })

    }

    confirmEvent = () => {
        const eventId = this.state.clickedConnectedEvent.event.id
        const messageId = this.state.clickedMessageId
        const confirmedBy = 'user'
       
        doSetConfirmedEvent(eventId, messageId, confirmedBy)
      
        this.closeDetails()
    }

    rejectEvent = () => {
        this.setState({popUp: {
            active: true,
            type: 'warning',
            title: 'Hilfegesuch absagen?',
            content: 'Wollen Sie das Hilfegesuch wirklich absagen?',
            buttonConfig: 'popUp',
            userInput: ''
        }})

    }
    rejectEventConfirmed = () => {
      
        const message = this.props.myInboxMessages[this.state.clickedArrIndex]
        const event = this.state.clickedConnectedEvent
        const userInput = this.state.popUp.userInput
        rejectConnectedEvent(message, event, userInput)

        this.closePopUp()
        this.closeDetails()
    }
    rejectEventCancelt = () => {
        this.closePopUp()
        this.closeDetails()
    }

    closeDetails = () => {
        this.setState({
            clickedMessageId: null,
            clickedArrIndex: null,
            clickedRequesterData: null,
            clickedConnectedEvent: null,
        })
    }
    closeConfirmedDetails = () => {
        this.setState({
            clickedConfirmedEventArrIndex: null,
            clickedConfirmedEventId: null,
        })
        
    }

    closePopUp = () => {
        this.setState({popUp: {active: false, title: null, content: null, buttonConfig: null, type: null, userInput: ''}})
    }

    setUserInput = (e) => {
        this.setState({popUp: {...this.state.popUp, userInput: e.target.value }})
    }


    render () {
        const buttonsConfig = {
            popUp: [
                {title: 'Bestätigen', color:'primary', onClick:this.rejectEventConfirmed, disabled: this.state.popUp.userInput.length<4},
                {title: 'Abbruch', color:'secondary', onClick:this.rejectEventCancelt, disabled: false}
            ]
        }
        
        const { myInboxMessages, inboxCounter } = this.props
        return (
            <DefaultPage headline={{headlineText: 'Nachrichten Center'}} >
                <MessagingInbox 
                    title='Posteingang'
                    inboxItems={myInboxMessages}
                    inboxCounter={inboxCounter}
                    itemClickCallback={this.itemClickCallback}
                    clickedMessageId = {this.state.clickedMessageId}
                    clickedArrIndex = {this.state.clickedArrIndex}
                    clickedRequesterData = {this.state.clickedRequesterData}
                    clickedEvent = {this.state.clickedMessageId ? myInboxMessages[this.state.clickedArrIndex] : null}
                    functions = {{
                        itemDetails: {
                            closeDetails: this.closeDetails,
                            rejectEvent: this.rejectEvent,
                            confirmEvent: this.confirmEvent,
                        }
                    }}
                    />
            {this.state.popUp.active
                ?<PopUp
                    type={this.state.popUp.type}
                    title={this.state.popUp.title}
                    content={this.state.popUp.content}
                    buttons={buttonsConfig[this.state.popUp.buttonConfig]}
                    userInput={input =>this.setUserInput(input)}

                />
                : null
            }
            <div style={{marginTop: '16px'}}>
                <MessagingConfirmedEvents
                    title='Bestätigte Hilfeangebote'
                    items={this.props.myConfirmedEvents}
                    itemCounter={this.props.myConfirmedEventsCounter}
                    itemClickCallback={this.confirmedItemClickCallback}
                    clickedArrIndex = {this.state.clickedConfirmedEventArrIndex}
                    clickedItemId = {this.state.clickedConfirmedEventId}
                    //clickedArrIndex = {this.state.clickedArrIndex}
                    //clickedRequesterData = {this.state.clickedRequesterData}
                    //clickedEvent = {this.state.clickedConnectedEvent}
                    functions = {{
                        itemDetails: {
                            closeDetails: this.closeConfirmedDetails,
                        }
                    }}
                />
            </div>
            </DefaultPage>    
        )
    }
}

const mapStateToProps = (state) =>({
    myInboxMessages: state.messagingState.myInbox,
    inboxCounter: state.messagingState.inboxCounter,
    myConfirmedEvents: state.eventState.myConfirmedEvents,
    myConfirmedEventsCounter: state.eventState.myConfirmedEventsCounter,
    userId: state.userState.profile.id
                                               
})



export default connect (mapStateToProps)(MyMessagingCenter)


// WEBPACK FOOTER //
// ./src/Components/MessagingCenter/MyMessagingCenter.js